import { render } from "./ToolTip.vue?vue&type=template&id=56807ffc"
import script from "./ToolTip.vue?vue&type=script&lang=js"
export * from "./ToolTip.vue?vue&type=script&lang=js"

import "./ToolTip.vue?vue&type=style&index=0&id=56807ffc&lang=css"

import exportComponent from "/Users/trifjolngjela/Projects/home-budget/home-budget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
